import styled from 'styled-components';

export const Container = styled.div`
  height: 0;
  opacity: 0;
  overflow: hidden;

  transition: height 0.3s ease, opacity 0.3s ease-in;
`;
